/* COCOMII makeover behaviour (2026-10-28, design/makeover-2026-10/DIRECTION.md). Loaded deferred, last in <body>,
   by layout/theme.liquid (id cocomii-makeover-js). Self-contained: it reads no theme.js state and changes no theme
   element except body.cocomii-header-solid on the homepage (the class collection pages already use).
   1. Reveals: [data-mk-reveal] fades up, [data-mk-clip] wipes open. Elements already on screen when the script runs
      are marked at once, so nothing visible ever blinks out. Nothing is hidden without IntersectionObserver or in the
      theme editor (sections there re-render at any time).
   2. Hero video: the source is attached after window load; never under reduced motion, data saver or a paused visit.
   3. Homepage header: solid once the hero has scrolled past the header (same rule as collection pages), and solid
      from the start when the homepage has no hero (the transparent header would leave a white logo on ivory).
   4. Model index: the preview follows the hovered or focused row.
   5. Hero drift: a slow parallax on the hero media, desktop pointers only, off under reduced motion.
   6. Pause motion (WCAG 2.2.2): [data-mk-motion-toggle] pauses the hero video, the ticker (html.mk-motion-paused)
      and the announcement rotation (part 10); the choice is remembered on the device when storage allows. One button
      shows: the hero's, else the ticker's.
   7. Collection pages with the ivory makeover header: the header bar stays solid (round 2, 2026-10-29).
   8. Style Edit articles: a contents list from the article's own h2s (round 2), and the closing "Related reading"
      heading and list marked for the house styles (round 27).
   9. Cart drawer steadiness (rounds 23b, 23c): #CartDrawer.mk-cart-adding while a rebuild of an empty cart is in
      flight, and the wallet stack's height kept as its min-height while the drawer is open.
  10. Announcement rotation (round 24): the theme's slider stops turning under reduced motion or Pause motion (with
      part 9, the only other theme elements this script touches).
   Theme editor: a section the editor re-renders (shopify:section:load) is initialised again, and the announcement bar
   is moved back into the header (round 29). A page restored from the back-forward cache reads Pause motion again. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var body = document.body;
  if (!body) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var isHome = body.classList.contains('template-index');
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var PAUSE_KEY = 'cocomii-motion-paused';
  var paused = false;
  try { paused = window.localStorage.getItem(PAUSE_KEY) === '1'; } catch (e) {}

  // 1. Reveals. A [data-mk-clip] element starts fully clipped (clip-path inset 100%), and the browser counts a fully
  // clipped element as having no visible area, so it would never intersect: such elements are watched through their
  // parent instead (2026-10-28, found in the preview: the photos never appeared while the text did).
  var groups = window.Map ? new Map() : null;
  var io = null;
  if (groups && 'IntersectionObserver' in window && !designMode) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }
  var reveal = function (watch) {
    (groups.get(watch) || []).forEach(function (el) { el.classList.add('is-in'); });
    groups.delete(watch);
  };
  var initReveals = function (root) {
    var items = root.querySelectorAll('[data-mk-reveal], [data-mk-clip]');
    if (!items.length) return;
    if (!io) { each(items, function (el) { el.classList.add('is-in'); }); return; }
    var fresh = [];
    each(items, function (el) {
      if (el.classList.contains('is-in')) return;
      var watch = el.hasAttribute('data-mk-clip') && el.parentElement ? el.parentElement : el;
      if (!groups.has(watch)) { groups.set(watch, []); fresh.push(watch); }
      groups.get(watch).push(el);
    });
    var vh = doc.clientHeight || window.innerHeight;
    fresh.forEach(function (watch) {
      var r = watch.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) reveal(watch); else io.observe(watch);
    });
    doc.classList.add('mk-js');
  };

  // 2 + 3 + 5. Hero
  var header = document.querySelector('.site-header');
  var hero = null;
  var media = null;
  var video = null;
  var ticking = false;
  var playVideo = function () {
    if (!video || reduce || saveData || paused) return;
    var source = video.querySelector('source[data-src]');
    if (source && !source.getAttribute('src')) { source.setAttribute('src', source.getAttribute('data-src')); video.load(); }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  };
  var update = function () {
    ticking = false;
    if (hero && !doc.contains(hero)) { hero = null; media = null; video = null; }
    if (!header || !doc.contains(header)) header = document.querySelector('.site-header');
    if (isHome) {
      if (!hero) body.classList.add('cocomii-header-solid');
      else {
        var headerBottom = header ? header.getBoundingClientRect().bottom : 120;
        body.classList.toggle('cocomii-header-solid', hero.getBoundingClientRect().bottom <= headerBottom);
      }
    }
    if (hero && media && finePointer && !reduce) {
      // Drift down only, once the hero's top has passed the top of the window: at rest the hero sits below the
      // announcement bar, and an upward shift there would bare a strip of the hero's ink ground at its bottom.
      var rect = hero.getBoundingClientRect();
      if (rect.bottom > 0) media.style.transform = 'translate3d(0,' + Math.round(Math.max(0, -rect.top) * 0.18) + 'px,0)';
    }
  };
  var bound = false;
  var bind = function () {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    // After a single jump (a restored scroll position, an anchor link) the theme slides the stuck header in, and the
    // header's edge is read mid-slide; the state is settled again when scrolling stops, when that slide ends, and
    // after load.
    window.addEventListener('scrollend', update, { passive: true });
    window.addEventListener('load', update, { once: true });
    window.addEventListener('resize', update);
    if (header) { header.addEventListener('transitionend', update); header.addEventListener('animationend', update); }
  };
  var initHero = function (root) {
    var h = root.querySelector('[data-mk-hero]');
    if (!h) return;
    hero = h;
    media = h.querySelector('[data-mk-hero-parallax]');
    video = h.querySelector('[data-mk-hero-video]');
    if (video) {
      video.addEventListener('playing', function () { h.classList.add('is-playing'); }, { once: true });
      if (document.readyState === 'complete') setTimeout(playVideo, 250);
      else window.addEventListener('load', function () { setTimeout(playVideo, 250); }, { once: true });
    }
    bind();
  };

  // 4. Model index preview. A row without a photo of its own keeps the current one rather than blanking the frame.
  var initModels = function (root) {
    each(root.querySelectorAll('[data-mk-models]'), function (sec) {
      var preview = sec.querySelector('.mk-models__preview');
      var imgs = sec.querySelectorAll('[data-mk-preview]');
      if (!preview || !imgs.length) return;
      var show = function (i) {
        var found = false;
        each(imgs, function (im) { if (im.getAttribute('data-mk-preview') === i) found = true; });
        if (!found) return;
        preview.classList.add('has-active');
        each(imgs, function (im) { im.classList.toggle('is-active', im.getAttribute('data-mk-preview') === i); });
      };
      each(sec.querySelectorAll('[data-mk-model]'), function (row) {
        var i = row.getAttribute('data-mk-model');
        row.addEventListener('mouseenter', function () { show(i); });
        row.addEventListener('focus', function () { show(i); });
      });
    });
  };

  // 6. Pause motion
  var toggles = [];
  var applyPause = function (fromUser) {
    doc.classList.toggle('mk-motion-paused', paused);
    toggles.forEach(function (b) { b.setAttribute('aria-pressed', paused ? 'true' : 'false'); });
    if (video) {
      if (paused) video.pause();
      else if (fromUser) playVideo();
    }
    if (fromUser) setAnnouncement(true);
  };
  var initToggles = function (root) {
    each(root.querySelectorAll('[data-mk-motion-toggle]'), function (b) {
      if (b.hasAttribute('data-mk-wired')) return;
      b.setAttribute('data-mk-wired', '');
      toggles.push(b);
      b.addEventListener('click', function () {
        paused = !paused;
        try { window.localStorage.setItem(PAUSE_KEY, paused ? '1' : '0'); } catch (e) {}
        applyPause(true);
      });
    });
    // The hero's copies win (CSS shows one of the two per width); the ticker's own shows only without a hero button.
    toggles = toggles.filter(function (b) { return doc.contains(b); });
    var inHero = function (b) { return !!(b.closest && b.closest('[data-mk-hero]')); };
    var heroHasToggle = toggles.some(inHero);
    toggles.forEach(function (b) { b.hidden = reduce || (heroHasToggle && !inHero(b)); });
    applyPause(false);
  };
  // (round 29) A page restored from the back-forward cache keeps the Pause motion state it had when the visitor left,
  // though the choice may have changed on another page since: read the stored choice again and apply it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var stored = paused;
    try { stored = window.localStorage.getItem(PAUSE_KEY) === '1'; } catch (err) {}
    if (stored !== paused) { paused = stored; applyPause(true); }
  });

  // 7. Collection pages with the makeover's ivory header: the theme's transparent bar has a white logo, which would vanish
  // on ivory, so the bar stays solid (the theme's own banner script finds no banner and leaves the class alone).
  var initCollectionHead = function (root) {
    if (!body.classList.contains('template-collection') || !root.querySelector('[data-mk-collhead]')) return;
    // the theme's own banner switched back on owns the bar state (its script toggles the class over the banner)
    if (document.querySelector('[data-section-type="collection-header"], [id$="__collection-header"]')) return;
    body.classList.add('cocomii-header-solid');
  };

  // 8. Style Edit contents list (round 2): built from the article's own top-level h2s, whose text is never touched (an
  // id is added where a heading has none, so the links can jump). Four headings or more; the CSS shows a sticky rail
  // from 1300 px and a collapsible "Contents" below that; the rail marks the section being read.
  var escapeHtml = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // Since round 29 sections/article-template.liquid renders the list and the heading ids itself (in the first paint),
  // so only the rail's current-section mark is wired here; the build below is the fallback for markup without it.
  var markToc = function (rail) {
    if (rail.hasAttribute('data-mk-wired') || !('IntersectionObserver' in window)) return;
    rail.setAttribute('data-mk-wired', '');
    var links = rail.querySelectorAll('a');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        each(links, function (a) { a.classList.toggle('is-current', a.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-15% 0px -75% 0px' });
    each(links, function (a) { var h = document.getElementById(a.getAttribute('href').slice(1)); if (h) obs.observe(h); });
  };
  var initToc = function (root) {
    if (!body.classList.contains('template-article')) return;
    var art = root.querySelector('.article__body');
    if (!art) return;
    var served = art.parentNode.querySelector('.mk-toc--rail');
    if (served) { markToc(served); return; }
    if (art.hasAttribute('data-mk-toc')) return;
    var hs = Array.prototype.filter.call(art.children, function (el) { return el.tagName === 'H2' && el.textContent.trim(); });
    if (hs.length < 4) return;
    art.setAttribute('data-mk-toc', '');
    var items = hs.map(function (h, i) {
      if (!h.id) {
        var base = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || ('section-' + (i + 1));
        var id = base, n = 2;
        while (document.getElementById(id)) id = base + '-' + n++;
        h.id = id;
      }
      return '<li><a href="#' + h.id + '">' + escapeHtml(h.textContent.trim()) + '</a></li>';
    }).join('');
    var rail = document.createElement('nav');
    rail.className = 'mk-toc mk-toc--rail';
    rail.setAttribute('aria-label', 'Contents');
    rail.innerHTML = '<div class="mk-toc__inner"><p class="mk-toc__label">Contents</p><ol>' + items + '</ol></div>';
    var inline = document.createElement('details');
    inline.className = 'mk-toc mk-toc--inline';
    inline.innerHTML = '<summary>Contents</summary><nav aria-label="Contents"><ol>' + items + '</ol></nav>';
    art.parentNode.insertBefore(rail, art);
    art.parentNode.insertBefore(inline, art);
    if ('IntersectionObserver' in window) {
      var links = rail.querySelectorAll('a');
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          each(links, function (a) { a.classList.toggle('is-current', a.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      hs.forEach(function (h) { obs.observe(h); });
    }
  };
  // (round 27, review rank 56) The article's closing "Related reading" heading and the list after it take the house label
  // and link rows (cocomii-makeover.css); found by the heading's text, the last such heading in the body.
  var initRelated = function (root) {
    if (!body.classList.contains('template-article')) return;
    var art = root.querySelector('.article__body');
    if (!art) return;
    var rel = Array.prototype.filter.call(art.querySelectorAll('h2, h3, h4'), function (h) { return /^\s*related reading\s*:?\s*$/i.test(h.textContent); }).pop();
    var list = rel && rel.nextElementSibling;
    if (!list || !/^(UL|OL)$/.test(list.tagName)) return;
    rel.classList.add('mk-related');
    list.classList.add('mk-related__list');
  };

  // 9. Cart drawer steadiness (owner 2026-11-03: "Every time I open cart drawer, the bottom frame shakes"). (a) The
  // theme opens the drawer on ajaxProduct:added while its cart fetch is still running, so an add to an empty cart
  // showed "Your cart is currently empty" for a moment: the drawer carries mk-cart-adding (CSS hides the empty state)
  // until the rebuild lands, 2 s at most. (b) The wallet buttons show only once the drawer leaves is-empty and
  // can change height a moment later (3 placeholder rows to 2 buttons measured: 48 px), which moved CHECK OUT: their
  // height while the drawer is open is kept as their min-height and released once it is shut (round 23c, review: a
  // stack that settled shorter must not leave a strip for the rest of the visit). The guard starts on the theme's two
  // rebuild events, ajaxProduct:added (product forms, the cards since round 23c, the Case Wardrobe) and cart:build
  // (Pair it with), and ends when the theme drops is-empty or rewrites the item list (the cart is known then even if
  // it is still empty). Class changes are compared before they are made, so the observer never feeds itself.
  var initCartDrawer = function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__mkSteady) return;
    drawer.__mkSteady = true;
    var timer = null, locked = false;
    var wallets = function () { return drawer.querySelector('.additional-checkout-buttons'); };
    var lockWallets = function () {
      if (locked) return;
      var w = wallets(), h = w ? w.offsetHeight : 0;
      if (h > 0) { w.style.minHeight = h + 'px'; locked = true; }
    };
    var releaseWallets = function () {
      if (!locked) return;
      var w = wallets();
      if (w) w.style.minHeight = '';
      locked = false;
    };
    var settle = function () {
      if (timer) { clearTimeout(timer); timer = null; }
      if (drawer.classList.contains('mk-cart-adding')) drawer.classList.remove('mk-cart-adding');
    };
    var onRebuild = function () {
      if (!drawer.classList.contains('is-empty') || drawer.classList.contains('mk-cart-adding')) return;
      drawer.classList.add('mk-cart-adding');
      timer = setTimeout(settle, 2000);
    };
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var cls = drawer.classList;
        if (!cls.contains('drawer--is-open') && !cls.contains('is-transitioning')) releaseWallets();
        if (cls.contains('is-empty')) return;
        if (cls.contains('drawer--is-open')) lockWallets();
        settle();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      var items = drawer.querySelector('[data-products]');
      if (items) new MutationObserver(function () { if (drawer.classList.contains('mk-cart-adding')) settle(); }).observe(items, { childList: true });
    }
    ['ajaxProduct:added', 'cart:build'].forEach(function (name) { document.addEventListener(name, onRebuild); });
  };

  // 10. Announcement rotation (round 24, review rank 32): the theme's slider turns every 5 s; with reduced motion or
  // Pause motion it stays on the first message (a swipe still turns it), and Pause motion pressed again restarts it.
  // The theme builds the slider after this script runs and builds it again when the screen crosses its phone
  // breakpoint (matchSmall, unmatchSmall), so the stop is applied on load and after the theme's own handlers.
  var setAnnouncement = function (resume) {
    var bar = document.getElementById('AnnouncementSlider');
    var fl = bar && window.Flickity && typeof window.Flickity.data === 'function' ? window.Flickity.data(bar) : null;
    if (!fl || !fl.options || !fl.options.autoPlay) return;
    if (reduce || paused) fl.stopPlayer();
    else if (resume) fl.playPlayer();
  };
  var setAnnouncementLater = function () { window.setTimeout(function () { setAnnouncement(false); }, 0); };
  if (document.readyState === 'complete') setAnnouncementLater();
  else window.addEventListener('load', setAnnouncementLater);
  // the theme editor's block deselect plays the slider again (theme.announcementBar.onBlockDeselect): stop it after
  ['matchSmall', 'unmatchSmall', 'shopify:block:deselect'].forEach(function (name) { document.addEventListener(name, setAnnouncementLater); });

  var init = function (root) {
    initReveals(root);
    initHero(root);
    initModels(root);
    initToggles(root);
    initCollectionHead(root);
    initToc(root);
    initRelated(root);
  };
  init(document);
  initCartDrawer();
  if (isHome) { bind(); update(); }
  // (round 29) In the theme editor a re-rendered header section brings the announcement bar back outside the header's
  // wrapper, and its inline mover (sections/header.liquid) does not run on injected HTML: move it in again here, as the
  // mover does on a page load.
  var moveAnnouncement = function () {
    var a = document.querySelector('.announcement-bar'), w = document.querySelector('.header-sticky-wrapper');
    if (a && w && !w.contains(a)) w.insertBefore(a, w.firstChild);
  };
  document.addEventListener('shopify:section:load', function (e) { moveAnnouncement(); if (e.target) { init(e.target); update(); } initCartDrawer(); setAnnouncementLater(); });
})();
